export enum OrderHistoryEventActionType {
    CancelProduct = 'Cancel product',
    CancelOrder = 'Cancel order',
    ReturnProduct = 'Return product',
    ContactSeller = 'Email logo',
    DownLoadInvoice = 'Download invoices',
    NavigateToSeller = 'Seller navigation clicked',
    NavigateToDeliveryCarrier = 'Delivery carrier navigation clicked',
    PDPLinkOrderHistory = 'Product Link Clicked',
    ShowNextOrdersButton = 'show_next_orders_button_interaction',
    GetInvoiceButton = 'get_invoice_button_interaction',
    PaymentShipmentInfo = 'payment_and_shipment_info_interaction',
    BuyAgain = 'buy_it_again_button_clicked',
    BuyAgainShowMoreProducts = 'Buy Again Show More Products',
    BuyAgainProductNotShown = 'Product not shown',
    BuyAgainChangeProductQuantity = 'Change product quantity',
    BuyAgainPersonalProductShown = 'Personal purchases availability',
}
